<div class="container-fluid">
  <app-header titleText="WORK ORDERS" i18n-titleText progressBarState="workorder"></app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/project_management_circle.png" alt="Job Icon" class="card-icon" />
      <h5 i18n>Work Order List</h5>

      <form class="row" (ngSubmit)="refreshSummary()">
        <div class="col-sm-3">
          <input name="projectName" id="projectName"
                 class="form-control" placeholder="Search Projects" i18n-placeholder
                 [(ngModel)]="filter.projectName" #projectName="ngModel" />
        </div>
        <div class="col-sm-3">
          <select name="customerId" id="customerId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.customerId" #customerId="ngModel">
            <option selected="selected" value="undefined" i18n>Select Customer</option>
            <option *ngFor="let customer of summary?.customers" [ngValue]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <mat-select class="form-control"
                      [(value)]="filter.crew">
            <mat-select-trigger>
              <div *ngIf="filter.crew; else noCrew">
                <div class="color-swatch"
                     [style.background-color]="filter.crew.crew_Color">&nbsp;</div>
                {{filter.crew.crew_Name}}
              </div>
              <ng-template #noCrew i18n>Select Crew</ng-template>
            </mat-select-trigger>
            <mat-option value="" i18n>Select Crew</mat-option>
            <mat-option *ngFor="let crew of summary?.crews" [value]="crew">
              <div class="color-swatch" [style.background-color]="crew.crew_Color">&nbsp;</div>
              {{crew.crew_Name}}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-3">
          <select name="jobTypeId" id="jobTypeId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.jobTypeId" #jobTypeId="ngModel">
            <option [ngValue]="null" i18n>Select Job Type</option>
            <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
          </select>
        </div>
        <div class="col-3">
            <div class="form-inline">
              <label for="startDate" class="col-form-label mr-1" i18n>Start Date</label>
              <div class="form-inline">
                <input name="startDateCtrl" id="startDateCtrl" class="form-control narrow-input" matInput
                       placeholder="mm/dd/yyyy"
                       [matDatepicker]="startPicker"
                       [(ngModel)]="filter.startDate" #startDateCtrl="ngModel" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </div>
            </div>
        </div>
        <div class="col-3">
            <div class="form-inline">
              <label for="endDate" class="col-form-label mr-1" i18n>End Date</label>
              <div class="form-inline">
                <input name="endDateCtrl" id="endDateCtrl" class="form-control narrow-input" matInput
                       placeholder="mm/dd/yyyy"
                       [matDatepicker]="endPicker"
                       [(ngModel)]="filter.endDate" #endDateCtrl="ngModel" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </div>
            </div>
        </div>
        <div class="col-sm-3">
        </div>
        <div class="col-sm-3">
          <button type="submit" class="btn btn-bidit-action mt-2" onclick="this.blur();" i18n>Apply Filter</button>
        </div>
      </form>

      <h5 i18n>Click edit icon name to edit work order information</h5>
      <app-spinner [isRunning]="dataSource.loading$ | async"></app-spinner>

      <mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                 matSort matSortActive="projectName" matSortDirection="asc">
        <ng-container matColumnDef="projectName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Name</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.project.quote_Name}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="projectNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Nbr</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.project.quote_ProjectNumber}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.customer.customer_BusinessName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="workOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Work Order</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.project.quote_ProjectNumber}}-{{workOrder.workOrder_Seq}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="workOrderType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Work Order Type</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.workOrderType?.workOrderType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="jobType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Job Type</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.project.jobType?.jobType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="workOrderStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Status</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
              {{getWorkOrderStatusName(workOrder.workOrderStatus_ID)}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Start Date</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            {{workOrder.workOrder_Start | date: 'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="crew">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Crew</mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            <div style="display: block">
              <div *ngFor="let woc of workOrder.workOrderCrews">
                {{woc.crew?.crew_Name}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="bidit-header"></mat-header-cell>
          <mat-cell *matCellDef="let workOrder">
            <div *ngIf="!isRequesting">
              <button *ngIf="canEdit" (click)="editWorkOrder(workOrder)" class="btn btn-bidit-edit mr-1"></button>
              <button *ngIf="canEdit" (click)="workOrderResources(workOrder)" class="btn btn-bidit-navigate mr-1" i18n>Resources</button>
              <button *ngIf="canEdit" (click)="workOrderLabor(workOrder)" class="btn btn-bidit-navigate mr-1" i18n>Labor</button>
              <button (click)="printWorkOrder(workOrder)" class="btn btn-bidit-action" onclick="this.blur();" i18n>Print</button>
            </div>
            <app-spinner [isRunning]="isRequesting"></app-spinner>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="summary?.workOrderCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
